import ApiService from '@Utils/apiService'
import * as Path from './apiRoutes'
import { formatAmount, parseAmount, formatDate } from '@Utils/formatters'
import { cloneDeep } from 'lodash'
import moment from 'moment'
// Import the action creators
import * as Actions from './actions'
import { formatDatetime } from '../../../../../utils/formatters'

export const getListOnboardingTrainingTracker = () => (dispatch, getState) => {
    dispatch(Actions.isLoading(true))
    const { onboardingTrainingTrackerList: { resultTable: { appliedFilter } } } = getState()
    const { auth } = getState()
    let sortModel = null
    let updateSortModel = cloneDeep(appliedFilter)
    if (Object.keys(updateSortModel.Sort).length > 0) {
        let currentSortModel = updateSortModel.Sort
        sortModel = {
            Column: currentSortModel.field,
            Order: currentSortModel.sort
        }
    }
    updateSortModel.Sort = sortModel
    updateSortModel.CompanyId = auth.credentials.companyId
    updateSortModel.UserID = auth.credentials.userId

    ApiService.get(Path.LIST, updateSortModel)
        .then((response) => {
            if (response) {
                const { data } = response
                dispatch(Actions.updateOnboardingTrainingTrackerList({
                    data: data.items,
                    totalCount: data.count,
                }))
            }
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.isLoading(false))
        })

}

export const getListTrainings = (id) => (dispatch, getState) => {
    dispatch(Actions.isLoading(true))
    const { onboardingTrainingTrackerDetail: { resultTable: { appliedFilter } } } = getState()
    let updateSortModel = dispatch(convertToTrainingModel(appliedFilter));
    
    return ApiService.get(Path.TRAINING_LIST + '/' + id, updateSortModel)
        .then((response) => {
            if (response) {
                const { data } = response
                dispatch(Actions.updateOnboardingTrainingTrackerList({
                    data: data.items,
                    totalCount: data.count,
                }))
            }
            return response; 
        })
        .catch((error) => {
            console.error(error)
            throw error;
        }).finally(() => {
            dispatch(Actions.isLoading(false))
        })
}

// ONBOARDING TRAINING TRACKER LIST ACTIONS/ACTION OPERATIONS
export const applySearchFilters = (searchModel) => (dispatch) => {
    // Page will always be zero upon searching
    dispatch(Actions.changeFilterPage(0))

    // dispatch the search filters
    dispatch(Actions.applyFilters(searchModel))

    // get data from server and update results
    dispatch(getListOnboardingTrainingTracker())
}

export const resetSearchResults = () => (dispatch) => {
    // reset filter
    dispatch(Actions.resetResults())
    // Update the list
    dispatch(getListOnboardingTrainingTracker())
}

export const resetFilters = () => (dispatch, getState) => {
    dispatch(Actions.resetFilters())
    return new Promise((resolve, reject) => {
        const { onboardingTrainingTrackerList: { searchFilter } } = getState()
        resolve(searchFilter)
    })
}

export const changePage = (newPage) => (dispatch) => {
    // dispatch change filter page
    dispatch(Actions.changeFilterPage(newPage))
    // Update the list
    dispatch(getListOnboardingTrainingTracker())
}

export const changeRowsPerPage = (pageModel) => (dispatch) => {
    // dispatch change filter page size
    dispatch(Actions.changeFilterRowsPerPage(pageModel))
    // Update list
    dispatch(getListOnboardingTrainingTracker())
}

export const changeSort = (sortModel) => (dispatch) => {
    // dispatch change filter page size
    dispatch(Actions.changeFilterSort(sortModel))
    // Update list
    dispatch(getListOnboardingTrainingTracker())
}


// ONBOARDING TRAINING TRACKER ADD ACTION OPERATIONS
export const createOnboardingTrainingTracker = (data) => (dispatch, getState) => {
    const { onboardingTrainingTrackerAdd: { alert } } = getState()
    let nAlert = { ...alert }

    dispatch(Actions.showLoading(true))

    return ApiService.post(Path.ROOT, data)
        .then((response) => {
            if (response) {
                let title = 'Create Success'
                const { message } = response.data
                let goBackToList = true

                if (response.data.returnCode <= 0) {
                    title = 'Create Failed'
                    goBackToList = false
                }

                nAlert = {
                    ...nAlert,
                    title: title,
                    show: true,
                    content: message,
                    goBackToListFlag: goBackToList,
                }
            }
        })
        .finally(() => {
            dispatch(Actions.showLoading(false))
            dispatch(Actions.updateAddAlertData(nAlert))
        })
}

// ONBOARDING TRAINING TRACKER DETAIL/UPDATE ACTION OPERATIONS
export const getOnboardingTrainingTrackerById = (id, mode) => (dispatch, getState) => {
    dispatch(Actions.hasDetailLoaded(false))
    return ApiService.get(Path.ROOT + '/' + id)
         .then((response) => {
            if (response.status === 200) {
                const { data } = response
                const converteddata = convertToViewModel(data)
                dispatch(Actions.setOnboardingTrainingTrackerDetail(converteddata, mode))
            } else {
                console.log('Failed to load data')
                console.log(data)
            }
            return response;
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.hasDetailLoaded(true))
        })
}

export const updateOnboardingTrainingTracker = (detailData, ID) => (dispatch, getState) => {
    dispatch(Actions.hasDetailLoaded(false))
    let updateModel = dispatch(convertToUpdateModel(detailData));

    let returnValue = {
        data: {},
        alertData: {
            show: true,
            title: 'Update success',
            content: 'Successfuly updated record.',
            confirmLabel: 'Ok',
        }
    }

    return ApiService.put(Path.ROOT + '/' + ID, updateModel)
        .then((response) => {
            if (response) {
                let title = 'Update Success'
                const { message } = response.data
                let goBackToList = true
                if (response.data.returnCode <= 0) {
                    title = 'Update Failed'
                    goBackToList = false
                }

                returnValue.data = response.data
                returnValue.alertData = {
                    show: true,
                    title: title,
                    content: message != null ? message : 'Successfully updated.',
                    confirmLabel: 'Ok',
                    goBackToListFlag: goBackToList,
                }
            }
            return returnValue;
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.hasDetailLoaded(true))
        })
}   

export const deleteOnboardingTrainingTracker = (data) => (dispatch) => {
    dispatch(Actions.isLoading(true))

    let returnValue = {
        data: {},
        alertData: {
            show: true,
            title: 'Update Success',
            content: 'Successfully deleted.',
            confirmLabel: 'Ok',
        }
    }

    return ApiService.delete(Path.ROOT + '/' + data)
        .then((response) => {
            if (response) {
                let title = 'Delete Success'
                const { message } = response.data
                if (response.data.returnCode <= 0) {
                    title = 'Delete Failed'
                }
                returnValue.data = response.data
                returnValue.alertData = {
                    show: true,
                    title: title,
                    content: message,
                    confirmLabel: 'Ok',
                }
            }
            return returnValue;
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.isLoading(false))
        })

}

export const exportOnboardingTrainingTrackerReport = (filename) => (dispatch, getState) => {
    dispatch(Actions.isLoading(true))
    const { onboardingTrainingTrackerList: { resultTable: { appliedFilter } } } = getState()
    const { auth } = getState()

    let sortModel = null
    let updateSortModel = cloneDeep(appliedFilter)
    if (Object.keys(updateSortModel.Sort).length > 0) {
        let currentSortModel = updateSortModel.Sort
        sortModel = {
            Column: currentSortModel.field,
            Order: currentSortModel.sort
        }
    }
    updateSortModel.Sort = sortModel
    updateSortModel.CompanyId  = auth.credentials.companyId

    return ApiService.export(Path.EXPORT, filename, updateSortModel)
        .then((response) => {
            return response
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.isLoading(false))
        })
}

export const exportOnboardingTrainingTrackerDetail = (filename, id) => (dispatch, getState) => {
    dispatch(Actions.isLoading(true))
    const { onboardingTrainingTrackerDetail: { resultTable: { appliedFilter } } } = getState()
    const { auth } = getState()

    let sortModel = null
    let updateSortModel = cloneDeep(appliedFilter)
    if (Object.keys(updateSortModel.Sort).length > 0) {
        let currentSortModel = updateSortModel.Sort
        sortModel = {
            Column: currentSortModel.field,
            Order: currentSortModel.sort
        }
    }
    updateSortModel.Sort = sortModel
    updateSortModel.ID = id
    updateSortModel.CompanyId  = auth.credentials.companyId

    return ApiService.export(Path.EXPORT_EMPLOYEE_DETAILS, filename, updateSortModel, id)
        .then((response) => {
            return response
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.isLoading(false))
        })
}

export const convertToUpdateModel = (data) => (dispatch, getState) => {
    const { auth } = getState()
    let userId = auth.credentials.userId
    return {
        ...data,
        UserID: userId,
    }
}

export const convertToViewModel = (data) => {
    return {
        ...data,
    }
}

export const convertToSearchModel = (data) => (dispatch, getState) =>{ 
    const { auth } = getState()
    let userId = auth.credentials.userId
    let companyId = auth.credentials.companyId
    return {
        ...data,
        UserID: userId,
        CompID: companyId,
        Pagination: {
            Page: (data.Pagination.Page - 1 < 0) ? 0 : data.Pagination.Page - 1,
            PageSize: data.Pagination.PageSize,
        },
    }
}

export const convertToTrainingModel = (data) => (dispatch, getState) =>{ 
    const { auth } = getState()
    let userId = auth.credentials.userId
    let companyId = auth.credentials.companyId
    return {
        ...data,
        UserID: userId,
        CompID: companyId,
        Pagination: {
            Page: (data.Pagination.Page - 1 < 0) ? 0 : data.Pagination.Page - 1,
            PageSize: data.Pagination.PageSize,
        },
    }
}

